export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20sneaker%20collection%20displayed%20on%20a%20clean%20wooden%20shelf%20with%20natural%20lighting%2C%20fashion%20lifestyle%20photography%20with%20neutral%20cream%20background%2C%20editorial%20style&width=400&height=300&seq=cat-shoes&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodie%20and%20sweater%20aesthetic%20flat%20lay%20on%20a%20warm%20neutral%20textured%20fabric%20background%2C%20soft%20pastel%20tones%2C%20minimal%20lifestyle%20photography&width=400&height=300&seq=cat-hoodies&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirts%20neatly%20folded%20and%20displayed%20on%20a%20minimal%20wooden%20surface%2C%20soft%20natural%20light%2C%20clean%20monochrome%20aesthetic%20with%20warm%20undertones&width=400&height=300&seq=cat-tshirts&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-bear-smile-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20lightweight%20jackets%20and%20outerwear%20displayed%20on%20minimal%20wooden%20hangers%2C%20clean%20studio%20setting%20with%20warm%20beige%20background%2C%20editorial%20fashion%20photography&width=400&height=300&seq=cat-jackets&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Casual%20pants%20and%20shorts%20styled%20on%20a%20minimal%20wooden%20surface%20with%20natural%20sunlight%2C%20warm%20neutral%20background%2C%20clean%20lifestyle%20fashion%20photography&width=400&height=300&seq=cat-pants&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-smile-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20headwear%20arranged%20on%20a%20minimal%20display%20shelf%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20fashion%20accessory%20photography&width=400&height=300&seq=cat-headwear&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20clothing%20sets%20and%20matching%20outfits%20displayed%20on%20a%20clean%20minimal%20surface%2C%20warm%20beige%20background%2C%20editorial%20fashion%20flat%20lay%20photography&width=400&height=300&seq=cat-sets&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-home-smile-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20underwear%20essentials%20neatly%20displayed%20on%20a%20minimal%20soft%20fabric%20surface%2C%20warm%20cream%20background%2C%20clean%20lifestyle%20product%20photography&width=400&height=300&seq=cat-underwear&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20jerseys%20and%20athletic%20wear%20displayed%20on%20minimal%20wooden%20hangers%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20background%2C%20sportswear%20photography&width=400&height=300&seq=cat-jersey&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20accessories%20collection%20including%20sunglasses%20and%20jewelry%20arranged%20on%20a%20minimal%20marble%20surface%2C%20warm%20cream%20background%2C%20editorial%20photography&width=400&height=300&seq=cat-accessories&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20bags%20and%20backpacks%20displayed%20on%20a%20clean%20minimal%20shelf%20with%20natural%20lighting%2C%20warm%20beige%20background%2C%20fashion%20accessory%20photography&width=400&height=300&seq=cat-bags&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20elegantly%20displayed%20on%20a%20minimal%20wooden%20surface%2C%20soft%20natural%20light%2C%20warm%20cream%20background%2C%20accessory%20photography&width=400&height=300&seq=cat-belts&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20displayed%20on%20a%20minimal%20marble%20surface%20with%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20luxury%20fragrance%20photography&width=400&height=300&seq=cat-perfumes&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20and%20miscellaneous%20items%20arranged%20on%20a%20clean%20minimal%20surface%2C%20warm%20neutral%20background%2C%20lifestyle%20product%20photography&width=400&height=300&seq=cat-other&orientation=landscape',
  },
];